import React, { useState } from "react";
import { PrimaryButton } from "@/components/Buttons";
import { disconnectClover } from "@/api/clover";

const CloverSettings = ({ settings, onDisconnect }) => {

  const handleSettingChange = (key, value) => {
    setSettings((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleSave = () => {
    // TODO: Implement save functionality for Clover settings
  };

  const handleDisconnect = async () => {
    try {
      await disconnectClover();
      onDisconnect();
    } catch (error) {
      // TODO: Show error notification
    }
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        
       
      </div>

      <div className="space-y-6">
        {/* Clover API Configuration */}
        <div>
          <h4 className="text-md font-medium text-slate-800 dark:text-slate-100 mb-4">
            API Configuration
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
                Merchant ID
              </label>
              <input
                type="text"
                value={settings.clover_merchant_id}
                disabled
                className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-md bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
                Merchant Name
              </label>
              <input
                type="text"
                value={settings.clover_merchant_name}
                disabled
                className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-md bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100"
              />
            </div>
          </div>
        </div>

        {/* Clover Data Sync Options */}
        <div>
          <h4 className="text-md font-medium text-slate-800 dark:text-slate-100 mb-4">
            Data Sync Options
          </h4>
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <div>
                <label className="text-sm font-medium text-slate-700 dark:text-slate-300">
                  Sync Inventory
                </label>
                <p className="text-xs text-slate-500 dark:text-slate-400">
                  Sync products, variants, and stock levels
                </p>
              </div>
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={settings.syncInventory}
                  onChange={(e) =>
                    handleSettingChange("syncInventory", e.target.checked)
                  }
                  className="sr-only peer"
                />
                <div className="w-11 h-6 bg-slate-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-indigo-300 dark:peer-focus:ring-indigo-800 rounded-full peer dark:bg-slate-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-slate-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-slate-600 peer-checked:bg-indigo-600"></div>
              </label>
            </div>

            <div className="flex items-center justify-between">
              <div>
                <label className="text-sm font-medium text-slate-700 dark:text-slate-300">
                  Push Orders
                </label>
                <p className="text-xs text-slate-500 dark:text-slate-400">
                  Push Saucey Direct Orders to your POS
                </p>
              </div>
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={settings.pushOrders}
                  onChange={(e) =>
                    handleSettingChange("pushOrders", e.target.checked)
                  }
                  className="sr-only peer"
                />
                <div className="w-11 h-6 bg-slate-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-indigo-300 dark:peer-focus:ring-indigo-800 rounded-full peer dark:bg-slate-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-slate-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-slate-600 peer-checked:bg-indigo-600"></div>
              </label>
            </div>

            <div className="flex items-center justify-between">
              <div>
                <label className="text-sm font-medium text-slate-700 dark:text-slate-300">
                  Pull Orders
                </label>
                <p className="text-xs text-slate-500 dark:text-slate-400">
                  Pull Orders from your POS for analytics
                </p>
              </div>
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={settings.pullOrders}
                  onChange={(e) =>
                    handleSettingChange("pullOrders", e.target.checked)
                  }
                  className="sr-only peer"
                />
                <div className="w-11 h-6 bg-slate-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-indigo-300 dark:peer-focus:ring-indigo-800 rounded-full peer dark:bg-slate-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-slate-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-slate-600 peer-checked:bg-indigo-600"></div>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CloverSettings;
